import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { AddToCartContext } from './AddToCartContext';
import CartItem from './CartItem';

import './CartDropdown.css'
import CartDropdownFooter from './CartDropdownFooter';
import CartDropdownFooterText from './CartDropdownFooterText';
import { formatPriceString } from '../modals/product/extended-product-modal/util/ProductModalHelpers';
import { CheckoutButtonClicked } from '../../../utils/Analytics.js'

const closeIcon = 'https://cdn.obsess-vr.com/umg/cart-close-icon.png';
const params = '&utm_source=virtualstore&utm_medium=referral';

const CartDropdown = ({ showDropdown, menuTextFontStyle, wishlistFontStyle,closeMenu }) => {
    const { cartList, cartSubTotal, pricePrefix, removeFromCart, shopifyWebUrl, CART_SESSION_STORAGE_KEY, resetCartList } = useContext(AddToCartContext);

    const handleCheckout = () => {
        CheckoutButtonClicked();
        let shopifyUrl = shopifyWebUrl+params;
        window.open(shopifyUrl, '_blank');

        //resetCartList();
        // once the user clicks checkout, session storage cart list is removed
        //sessionStorage.removeItem(CART_SESSION_STORAGE_KEY);
    }

    const renderCartItems = () => {
        return (
            <div className='cart-dropdown-item-container'>
                {cartList.map((item, index) => {
                    return (
                        <CartItem
                            key={index}
                            title={item.TITLE}
                            sku={item.SKU}
                            baseSKU={item.BASESKU}
                            price={item.PRICE}
                            size={item.SIZE}
                            titleAndSize={item.TITLE_AND_SIZE}
                            prefix={pricePrefix}
                            thumbnail={item.DOWNSIZED_THUMBNAIL}
                            menuTextFontStyle={menuTextFontStyle}
                            removeFromCart={removeFromCart}
                            quantity ={item.QUANTITY}
                            variantId ={item.VARIANT_ID}
                        />
                    )
                })}
            </div>
        );
    }

    const closeIconRender = () => {
        return (
            <div className="close-icon-container" onClick={closeMenu}> 
                <img src={closeIcon} className="cart-dropdown-close-icon" alt="close-icon" />
            </div>
        );
    }

    if (!showDropdown) {
        return (<div />);
    }
    return (
        <React.Fragment>
           {cartList.length !== 0 && <div id='add-to-cart-arrow' />}
            <div id='add-to-cart-menu'>
                {cartList.length !== 0 && closeIconRender()}
                {renderCartItems()}
                {cartList.length !== 0 && <div className='cart-Subtotal'>Subtotal
                    <span>{formatPriceString(cartSubTotal,pricePrefix)}</span>
                </div>}
                {cartList.length !== 0 && <CartDropdownFooter onClick={handleCheckout} />}
                {cartList.length !== 0 && wishlistFontStyle.text && <CartDropdownFooterText wishlistFontStyle={wishlistFontStyle} />}
            </div>
        </React.Fragment>
    );
}

CartDropdown.propTypes = {
    showMenu: PropTypes.bool,
    linkedStores: PropTypes.array,
    currentStoreIndex: PropTypes.number,
    menuTextFontStyle: PropTypes.object,
    menuTitle: PropTypes.string,
    sceneIdNameDict: PropTypes.object,
};

export default CartDropdown;
